var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88838 9.70703L5.26853 6.64989C5.73802 6.2055 6 5.61458 6 5C6 4.38542 5.73802 3.7945 5.26853 3.35011L1.88838 0.292968C1.68093 0.105384 1.39956 0 1.10619 0C0.812807 0 0.531445 0.105384 0.323995 0.292968C0.116545 0.480553 0 0.734972 0 1.00026C0 1.26554 0.116545 1.51996 0.323995 1.70754L3.70489 4.76468C3.77399 4.82719 3.81281 4.91195 3.81281 5.00033C3.81281 5.08872 3.77399 5.17348 3.70489 5.23598L0.323995 8.29246C0.116545 8.48004 0 8.73446 0 8.99974C0 9.26503 0.116545 9.51945 0.323995 9.70703C0.531445 9.89462 0.812807 10 1.10619 10C1.39956 10 1.68093 9.89462 1.88838 9.70703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.6edbe1b1839dda7629f049199d59e2cc.svg";
export { ForwardRef as ReactComponent };